var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.528.5a15.447 15.447 0 0 1 10.68 4.293l2.231-2.232C29.384 1.616 31 2.285 31 3.62V12a1.5 1.5 0 0 1-1.5 1.5h-8.379c-1.336 0-2.005-1.616-1.06-2.56l2.609-2.61a10.424 10.424 0 0 0-7.077-2.83C9.818 5.45 4.95 10.124 5 16.09c.048 5.66 4.636 10.41 10.5 10.41 2.57 0 5-.917 6.914-2.597a.749.749 0 0 1 1.023.034l2.48 2.48c.304.304.289.8-.03 1.089A15.443 15.443 0 0 1 15.5 31.5C6.94 31.5 0 24.56 0 16 0 7.45 6.978.485 15.528.5Z",
    fill: "#fff"
  })));
};

export default SvgReset;